@import (reference) '../../../../constants/spacing.module.less';
@import (reference) '../shared-fraud-styles.less';

.fraud-indicator-card {
  background: var(--white);
  border: 1px solid var(--grey-300);
  border-radius: 4px;
  padding: @space-12 @space-16;
  margin-bottom: @space-8;
}

.content-section {
  flex: 1;
  min-width: 0;
}

.card-icon {
  width: 16px;
  height: 16px;
  flex-shrink: 0;
}

// Use shared icon colors
.card-icon-blocks {
  .fraud-icon-blocks();
}

.card-icon-flags {
  .fraud-icon-flags();
}

.card-icon-info {
  .fraud-icon-info();
}

.card-title {
  margin: 0;
}

.dismiss-button {
  flex-shrink: 0;
  align-self: flex-start;
  margin-left: auto;
}

.blocking-badge {
  padding: @space-4 @space-8;
  border-radius: 4px;
  font-weight: 600;
  white-space: nowrap;
  align-items: center;
  align-self: flex-start;
}

.blocking-icon {
  font-size: 14px;
  line-height: 1;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 14px;
  height: 14px;
  color: inherit;
}

// Use shared badge styles with local structural overrides
.blocking-blocks {
  .fraud-badge-blocks();
}

.blocking-flags {
  .fraud-badge-flags();
}

.blocking-info {
  .fraud-badge-info();
}

.card-description-wrapper {
  margin-top: @space-12;
  align-items: baseline;
  flex-wrap: wrap;
}

.card-description,
.card-description-date,
.card-description-separator {
  margin: 0;
}
